const React = require("react");

const SubTitle = ({children}) => {
    return <h3 className="text-center">{children}</h3>
};
module.exports = SubTitle;